import { FC, lazy, Suspense } from 'react'
import { Props as BSProps } from 'react-spring-bottom-sheet/dist/types'
import { composeClasses } from '@/utils/compose-classes'
import Skeleton from '../skeleton'
import Portal from '../portal'

import 'react-spring-bottom-sheet/dist/style.css'

const BSComponent = lazy(() =>
  import('react-spring-bottom-sheet').then((module) => ({
    default: module.BottomSheet
  }))
)

export type BottomSheetProps = Omit<BSProps, 'onDismiss' | 'open'> & {
  isOpen: boolean
  onClose?: () => void | undefined
  className?: string
  isBlockingScroll?: boolean
  snapPoints?: BSProps['snapPoints']
}

export const BottomSheet: FC<BottomSheetProps> = ({
  isOpen,
  children,
  header,
  onClose,
  footer,
  className,
  isBlockingScroll = true,
  snapPoints,
  ...props
}) => {
  return (
    <>
      {isOpen && (
        <Suspense
          fallback={
            <Portal>
              <Skeleton
                className="absolute z-3 bottom-0 right-0 left-0"
                width="w-full"
                height="h-[200px]"
                rounded="!rounded-t-3xl"
              />
            </Portal>
          }
        >
          <BSComponent
            open={isOpen}
            header={header}
            scrollLocking={isBlockingScroll}
            onDismiss={onClose ? () => onClose() : undefined}
            footer={footer}
            snapPoints={snapPoints ?? (({ minHeight }) => minHeight)}
            {...props}
            className={composeClasses(
              className,
              'overflow-visible [>:data-rsbs-scroll]:overflow-visible'
            )}
          >
            {children}
          </BSComponent>
        </Suspense>
      )}
    </>
  )
}

export default BottomSheet
